<template>
  <b-container fluid class="legal-page px-0">
    <section class="legal-hero">
      <b-container>
        <b-row>
          <b-col cols="12" lg="9" class="mx-auto">
            <div class="legal-hero-inner">
            <!-- <p class="eyebrow mb-2">LEGAL</p> -->
            <h1 class="legal-title mb-3">Terms &amp; Conditions</h1>
            <p class="legal-desc mb-0">
              These Terms &amp; Conditions govern access to and use of the
              silver bullet<sup>®</sup> website, operated by Floating Knight Biotech.
            </p></div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section class="legal-section">
      <b-container>
        <b-row>
          <b-col cols="12" lg="10" xl="9" class="mx-auto">
            <div class="legal-card">
              <p class="last-updated mb-4">
                <strong>Last updated:</strong> 10/03/2026
              </p>

              <div class="legal-block">
                <p>
                  Welcome to the website of <strong>silver bullet<sup>®</sup></strong>, a
                  brand owned and operated by
                  <strong>Floating Knight Biotech</strong> (“Floating Knight
                  Biotech”, “silver bullet<sup>®</sup>”, “we”, “us”, or “our”).
                </p>
                <p class="mb-0">
                  By accessing or using this website, you agree to these Terms
                  &amp; Conditions. If you do not agree, please do not use this
                  website.
                </p>
              </div>


              <div class="legal-block">
                <h2>1. No Medical Advice</h2>
                <p class="mb-0">
                  The content on this website is for general information only
                  and should not be interpreted as medical, healthcare,
                  pharmaceutical, or regulatory advice. Users should consult
                  qualified professionals regarding any medical or health-related
                  matters.
                </p>
              </div>

              <div class="legal-block">
                <h2>2. Product Information</h2>
                <p class="mb-0">
                  Product descriptions, visuals, specifications, and availability
                  shown on this website are provided for general reference only.
                  They may be changed, updated, or withdrawn at any time without
                  notice. Product availability and regulatory status may vary by
                  market.
                </p>
              </div>

              <div class="legal-block">
                <h2>3. Future Product Categories</h2>
                <p class="mb-0">
                  Floating Knight Biotech and silver bullet<sup>®</sup> may expand their
                  portfolio over time, including into categories such as medical
                  devices or other regulated healthcare products. Any such
                  products remain subject to applicable laws, approvals, and
                  market-specific requirements.
                </p>
              </div>

              <div class="legal-block">
                <h2>4. Intellectual Property</h2>
                <p class="mb-0">
                  All website content, including text, graphics, layouts,
                  visuals, logos, and design elements, is owned by or licensed
                  to Floating Knight Biotech unless otherwise stated.
                  <strong>silver bullet<sup>®</sup></strong> is a trademark / registered
                  trademark used by Floating Knight Biotech. No content may be
                  copied, reproduced, distributed, or otherwise used without
                  prior written permission, except for personal, non-commercial
                  viewing.
                </p>
              </div>

              <div class="legal-block">
                <h2>5. Acceptable Use</h2>
                <p class="mb-2">You agree not to:</p>
                <ul class="legal-list mb-0">
                  <li>use the website in any unlawful or misleading manner</li>
                  <li>interfere with website operation or security</li>
                  <li>attempt unauthorized access to systems or data</li>
                  <li>transmit malicious code, spam, or harmful material</li>
                  <li>submit false, deceptive, or abusive inquiries</li>
                </ul>
              </div>

              <div class="legal-block">
                <h2>6. Third-Party Links</h2>
                <p class="mb-0">
                  This website may contain links to third-party websites for
                  convenience only. We do not control and are not responsible
                  for the content, availability, or privacy practices of such
                  third-party websites.
                </p>
              </div>

              <div class="legal-block">
                <h2>7. No Warranties</h2>
                <p class="mb-0">
                  This website and its content are provided on an “as is” and
                  “as available” basis. To the fullest extent permitted by law,
                  Floating Knight Biotech makes no express or implied
                  representations or warranties regarding accuracy,
                  completeness, availability, fitness for a particular purpose,
                  or non-infringement.
                </p>
              </div>

              <div class="legal-block">
                <h2>8. Limitation of Liability</h2>
                <p class="mb-0">
                  To the fullest extent permitted by applicable law, Floating
                  Knight Biotech shall not be liable for any direct, indirect,
                  incidental, consequential, or special damages arising out of
                  or related to the use of, or inability to use, this website or
                  its content.
                </p>
              </div>

              <div class="legal-block">
                <h2>9. Contact Forms and Communications</h2>
                <p class="mb-0">
                  Where this website provides a contact form or inquiry channel,
                  users must provide accurate and lawful information. Submission
                  of an inquiry does not create any contractual, advisory, or
                  commercial relationship unless expressly agreed in writing.
                </p>
              </div>

              <div class="legal-block">
                <h2>10. Changes to the Website</h2>
                <p class="mb-0">
                  We reserve the right to modify, suspend, restrict, or
                  discontinue any part of this website or its content at any
                  time without notice.
                </p>
              </div>

              <div class="legal-block">
                <h2>11. Changes to These Terms</h2>
                <p class="mb-0">
                  We may update these Terms &amp; Conditions from time to time.
                  Any updated version will be posted on this page with a revised
                  “Last updated” date.
                </p>
              </div>

              <div class="legal-block">
                <h2>12. Governing Law</h2>
                <p class="mb-0">
                  These Terms &amp; Conditions shall be governed by and
                  interpreted in accordance with the applicable laws of the
                  relevant jurisdiction in which Floating Knight Biotech
                  operates, unless otherwise required by mandatory law.
                </p>
              </div>

              <div class="legal-block mb-0">
                <h2>13. Contact</h2>
                <p class="mb-1">Floating Knight Biotech</p>
                <p class="mb-1">Brand: silver bullet <sup>®</sup></p>
                <p class="mb-1">Email: info@floatingknight.com</p>
                <!-- <p class="mb-0">Address: [Insert Registered Address]</p> -->
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </b-container>
</template>

<script>
export default {
  name: "Terms",

};
</script>

<style scoped>
.legal-page {
  background: transparent;
  color: #1f1f1a;
}

.legal-hero {
  padding: 44px 0 20px;
}

.eyebrow {
  font-size: 0.74rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #7b7a72;
  font-weight: 600;
}

.legal-title {
  font-size: 2.2rem;
  line-height: 1.08;
  letter-spacing: -0.02em;
  font-weight: 600;
  color: #1e1f1a;
  margin: 0;
}

.legal-desc {
  font-size: 0.96rem;
  line-height: 1.55;
  color: #66685f;
  max-width: 760px;
}

.legal-section {
  padding: 8px 0 52px;
}

.legal-card {
  border: 1px solid rgba(70, 70, 55, 0.08);
  border-radius: 22px;
  padding: 30px 32px;
  box-shadow: 0 14px 36px rgba(40, 42, 33, 0.04);
  background: transparent;
  max-width: 860px;
  margin: 0 auto;
}

.last-updated {
  font-size: 0.9rem;
  color: #6b6d64;
}

.legal-block {
  padding-top: 18px;
  margin-top: 18px;
  border-top: 1px solid rgba(70, 70, 55, 0.08);
}

.legal-block:first-of-type {
  padding-top: 0;
  margin-top: 0;
  border-top: 0;
}

.legal-block h2 {
  font-size: 1.02rem;
  line-height: 1.35;
  font-weight: 600;
  color: #20211c;
  margin-bottom: 8px;
}

.legal-block p,
.legal-list li {
  font-size: 0.94rem;
  line-height: 1.7;
  color: #5f6159;
}

.legal-list {
  padding-left: 1.2rem;
}

@media (max-width: 991.98px) {
  .legal-hero {
    padding: 36px 0 16px;
  }

  .legal-title {
    font-size: 1.9rem;
  }

  .legal-card {
    padding: 24px 20px;
    border-radius: 18px;
  }
}

.legal-hero-inner {
  max-width: 860px;
  margin: 0 auto;
}

.legal-title,
.legal-desc,
.eyebrow {
  text-align: left;
}

.legal-card {
  max-width: 860px;
  margin: 0 auto;
}
</style>